import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthUser } from '@bossanova/models';
import { ImageUrlPipe } from '../../pipes/image-url.pipe';

@Component({
  selector: 'bn-header',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  imports: [NgOptimizedImage, ImageUrlPipe, MatIconModule, MatMenuModule],
})
export class HeaderComponent {
  user = input<AuthUser | null>(null);
  paths = input.required<Record<string, string>>();
  appName = input.required<string>();
  leaveFeedback = output<void>();
}
